module.exports = __webpack_public_path__ + "static/movies-books-7e0f1b1f7e4837edcec0633b4e1109fa.jpg";